import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const fetchStructuredProducts = async ({ user, page, limit, search, status, from, to }) => {
  try {
    const query = new URLSearchParams({ page, limit });
    Object.entries({ search, status, from, to }).forEach(([key, value]) => value && query.set(key, value));
    const params = `?${query.toString()}`
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/list${params}`,
      buildHeaders(user)
    );
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchRegisteredUsers = async ({ user, page, limit, productId }) => {
  try {
    let params = `?page=${page}&limit=${limit}`
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/${productId}/registered-users${params}`,
      buildHeaders(user)
    );
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchInvestors = async ({ user, page, limit, productId }) => {
  try {
    let params = `?page=${page}&limit=${limit}`
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/${productId}/investors${params}`,
      buildHeaders(user)
    );
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchStructuredProductDetails = async ({ user, productId }) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/${productId}/details`,
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchStructuredProductsTrades = async ({ user, page, limit, startDate, endDate }) => {
  try {
    const params = `?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/trades${params}`,
      buildHeaders(user)
    );
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchStructuredProductGraphData = async ({ user, productId }) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/${productId}/graph`,
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const generateSpReport = async ({ user, productId }) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/structured-products/${productId}/report`, {},
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchSpReport = async ({ user, productId }) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/${productId}/report`,
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const refundStructuredProduct = async ({ user, productId }) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/structured-products/${productId}/refund`, {},
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}


export const fetchSpClosingPreview = async ({ user, productId }) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/${productId}/close/preview`,
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const closeStructuredProduct = async ({ user, productId }) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/structured-products/${productId}/close`, {},
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchSpIssues = async ({ user }) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/closed/issues`,
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const uploadSpTermSheet = async ({ user, productId, file }) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/structured-products/${productId}/term-sheet`, { file },
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const recomputeSpPercentages = async ({ user, productId }) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/structured-products/${productId}/percentages`, {},
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const fetchSpCouponsPreview = async ({ user, productId }) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/structured-products/${productId}/coupons/preview`,
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}

export const loadSpCoupons = async ({ user, productId }) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/structured-products/${productId}/coupons`, {},
      buildHeaders(user));
    return data;
  } catch (error) {
    throw error
  }
}
